import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div className="bg-white min-h-[70vh] flex items-center" data-testid="notfound-page">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-40 w-full">
        <span className="pm-overline">404</span>
        <h1 className="mt-4 font-heading text-4xl md:text-6xl font-semibold tracking-tight text-gray-900 max-w-3xl leading-[1.04]">
          We couldn't find that page.
        </h1>
        <p className="mt-5 text-gray-600 max-w-xl">
          The link may be outdated or mistyped. Return to the homepage to
          continue exploring Premier Modulations.
        </p>
        <Button
          asChild
          className="mt-10 bg-brand hover:bg-brand-hover text-white rounded-sm h-11 px-6"
          data-testid="notfound-home-cta"
        >
          <Link to="/">Back to home</Link>
        </Button>
      </div>
    </div>
  );
}
